import { types } from 'mobx-state-tree';
import { string } from 'mobx-state-tree/dist/internal';
import { BaseEntity } from './BaseEntity';

export const Group = types.compose(
  'Group',
  BaseEntity,
  types.model({
    groupId: types.identifierNumber,
    name: types.string,
    description: types.string,
    memberCount: types.maybe(types.number),
    color: types.string,
    targetDutyCount: types.number,
    targetDayDutyCount: types.number,
    targetNightDutyCount: types.number,
  }),
);